import { DataTest } from '@y42/data-test';

export interface DataTestBuilderSidebarInputNewTest {
  newTest: true;
  dataTests: DataTest[];
}
export interface DataTestBuilderSidebarInputEditTest {
  editIndex: number;
  dataTests: DataTest[];
}

export type DataTestBuilderSidebarInput = DataTestBuilderSidebarInputNewTest | DataTestBuilderSidebarInputEditTest;

export interface DataTestBuilderSaveOutput {
  dataTests: DataTest[];
}

export function isNewDataTest(input: DataTestBuilderSidebarInput): input is DataTestBuilderSidebarInputNewTest {
  const newTest: keyof DataTestBuilderSidebarInputNewTest = 'newTest';
  return newTest in input;
}

export function isEditDataTest(input: DataTestBuilderSidebarInput): input is DataTestBuilderSidebarInputEditTest {
  const editIndex: keyof DataTestBuilderSidebarInputEditTest = 'editIndex';
  return editIndex in input;
}
